const HYDRATE = 'luft-promo/init/HYDRATE';

export default {
  HYDRATE,
};
